import { render } from "./mySkills.vue?vue&type=template&id=4be5887e&scoped=true"
import script from "./mySkills.vue?vue&type=script&lang=js"
export * from "./mySkills.vue?vue&type=script&lang=js"

import "./mySkills.vue?vue&type=style&index=0&id=4be5887e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be5887e"]])

export default __exports__